import { useState } from 'react';
import { createPortal } from 'react-dom';

import { SabaCoinWithIcon } from '@/components/saba-coin-with-icon';
import { ThresholdButton } from '../threshold-button';
import { RedeemCashModal } from '../../redeem-cash-modal';
import { useReward } from '@/contexts/reward-context';

export const RedeemButton = ({ 
	thresholdId,
	redeemablePrice,
	requiredCoins 
}: { 
	thresholdId: number;
	redeemablePrice: number;
	requiredCoins: number;
}) => {
	const [isShowRedeemModal, setIsShowRedeemModal] = useState(false);
	const { onKafkaSet } = useReward();

	const openRedeemModal = () => {
		onKafkaSet({
			type: 3,
			action: 28
		});
		setIsShowRedeemModal(true);
	};

	const closeRedeemModal = () => {
		setIsShowRedeemModal(false);
	};

	return (
		<>
			<ThresholdButton onClick={openRedeemModal}>
				<SabaCoinWithIcon coin={requiredCoins} />
			</ThresholdButton>

			{isShowRedeemModal ? createPortal(
				<RedeemCashModal 
					thresholdId={thresholdId}
					redeemablePrice={redeemablePrice}
					requiredCoins={requiredCoins}
					onClose={closeRedeemModal} 
				/>, 
				document.getElementById('shop-wrapper')!
			) : null}
		</>
	);
};